export enum TrafficRequestStateEnum {
  NONE = "NONE",
  AFFILIATE = "AFFILIATE",
  QUALITY = "QUALITY"
}